import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TextAlpha } from '@yonderland/andes-react';
export const MiniPDPTitle = ({ productBrand, productTitle }) => (_jsxs(TextAlpha, { lineClamp: 1, children: [_jsx(TextAlpha, { strong: true, as: "span", children: productBrand }), ` ${productTitle}`] }));
